import axios, { InternalAxiosRequestConfig } from 'axios';
import { DefaultApi } from '../../client-sdk/api';
import { logoutAndRedirect } from './session';

export const createHimmaClient = (baseUrl: string): DefaultApi => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use(
    async (
      config: InternalAxiosRequestConfig<any>
    ): Promise<InternalAxiosRequestConfig<any>> => {
      const userDataString = localStorage.getItem('userData');

      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          const userId = userData.userId;
          const token = userData.token;

          if (token && userId) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.userId = userId;
          } else {
            config.headers.Authorization = 'Bearer';
          }
        } catch (error) {
          console.error('Error parsing userData:', error);
          config.headers.Authorization = 'Bearer';
        }
      } else {
        config.headers.Authorization = 'Bearer';
      }

      return config;
    }
  );

  // Global 401 handler
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        logoutAndRedirect();
      }
      return Promise.reject(error);
    }
  );

  return new DefaultApi(undefined, baseUrl, axiosInstance);
};
